import React from 'react';

const ToolList = ({ tools, selectedTool, onToolSelect }) => {
  return (
    <div className="tool-list">
      <div className="tool-list-header">
        <h1>loof.tool</h1>
        <p>tool-list</p>
      </div>
      {tools.map((tool) => (
        <button
          key={tool.id}
          className={`tool-btn ${selectedTool === tool.id ? 'active' : ''}`}
          onClick={() => onToolSelect(tool.id)} // 选择工具时调用父组件的回调函数
        >
          {tool.label}
        </button>
      ))}
    </div>
  );
};

export default ToolList;
